module.exports = __webpack_public_path__ + "hero-mobile.9ba64a81917b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/home/hero-mobile.jpg
// module id = ./src/styles/marketing/home/hero-mobile.jpg
// module chunks = 21